<template>
  <div class="post-page-container">
    <van-nav-bar
      placeholder
      fixed
      border
      left-arrow
      safe-area-inset-top
      left-text="班车服务大厅"
      @click-left="onBackClick"
    />
    <div class="post-page-content">
      <div class="post-wrapper">
        <div class="post-title">
          班车最新公告
        </div>
        <div class="content-wrapper">
          <div class="pulldown-bswrapper"
               ref="bsWrapper">
            <div class="pulldown-scroller">
              <div class="pulldown-wrapper">
                <div v-show="beforePullDown">
                  <span>下拉刷新</span>
                </div>
                <div v-show="!beforePullDown">
                  <div v-show="isPullingDown">
                    <span>加载中...</span>
                  </div>
                  <div v-show="!isPullingDown">
                    <span>刷新成功</span>
                  </div>
                </div>
              </div>
              <div class="post-list">
                <div class="post-card" v-for="(item, index) in list" :key="index">
                  <div class="left">
                    <div class="post-card-title">
                      {{ item.title }}
                    </div>
                    <div class="post-card-desc" v-html="item.content">
                    </div>
                    <div class="post-card-footer">
                      <div class="post-card-status">
                        <span></span>
                        <span>后勤基建处</span>
                      </div>
                    </div>
                  </div>
                  <div class="right-button">
                    <van-button type="primary"
                                class="main-button"
                                size="mini"
                                @click="toDetail(item)">详情
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="pullup-tips" v-if="pagination.page > 1">
                <div v-if="!isPullUpLoad" class="before-trigger">
                  <span class="pullup-txt">上拉刷新</span>
                </div>
                <div v-else class="after-trigger">
                  <span class="pullup-txt">加载中...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="post-button-wrapper" id="post-button-wrapper">-->
      <!--        <van-button type="primary" class="main-button" @click="toBuy">去预约</van-button>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';
import Notice from '@/apis/Notice';

BScroll.use(PullDown);
BScroll.use(PullUp);

// eslint-disable-next-line no-unused-vars
const TIME_BOUNCE = 800;
// eslint-disable-next-line no-unused-vars
const REQUEST_TIME = 1000;
const THRESHOLD = 40;
const STOP = 56;
// eslint-disable-next-line no-unused-vars
const STEP = 0;

export default {
  name: 'Announcement',
  data() {
    return {
      beforePullDown: true,
      isPullingDown: false,
      bscroll: undefined,
      isPullUpLoad: false,
      bottomHeight: 0,
      list: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.fetchList();
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  watch: {
    list(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const $dom = document.getElementsByClassName('post-card-desc');
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < $dom.length; i++) {
            $dom[i].innerText = `${$dom[i].innerText.slice(0, 70)}...`;
          }
        });
      }
    },
  },
  methods: {
    toBuy() {
      this.$router.push('/home');
    },
    onBackClick() {
      this.$router.replace('/');
    },
    toDetail(item) {
      this.$router.push({
        path: '/announcementDetail',
        query: { id: item.id },
      });
    },
    async fetchList() {
      const {
        page,
        limit,
      } = this.pagination;
      
     
      const res = await Notice.getList({
        page,
        limit,
      });
      this.pagination.total = Number(res.count);
      if (page === 1) {
        this.list = res.data;
        console.log('信息', this.list);
      } else {
        this.list.push(...res.data);
      }
    },
    initScroll() {
      this.bscroll = new BScroll(this.$refs.bsWrapper, {
        pullUpLoad: true,
        scrollY: true,
        click: true,
        taps: true,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP,
        },
      });
      this.bscroll.on('pullingDown', this.pullingDownHandler);
      this.bscroll.on('pullingUp', this.pullingUpHandler);
    },
    async pullingDownHandler() {
      console.log('trigger pullDown');
      this.beforePullDown = false;
      this.isPullingDown = true;
      this.pagination.page = 1;
      // STEP += 1;

      await this.fetchList();

      this.isPullingDown = false;
      await this.finishPullDown();
    },
    async finishPullDown() {
      this.bscroll.finishPullDown();
      setTimeout(() => {
        this.beforePullDown = true;
        this.bscroll.refresh();
      }, TIME_BOUNCE + 100);
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true;
      if (this.pagination.page * this.pagination.limit < this.pagination.total) {
        this.pagination.page += 1;
        await this.fetchList();
      }
      this.bscroll.finishPullUp();
      this.bscroll.refresh();
      this.isPullUpLoad = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";
@import "~@/assets/styles/variable.scss";

::v-deep .van-nav-bar__text {
  color: #fff;
}

.main-button {
  height: 40px;
  width: 100%;
  background-color: $brand-color;
  border-color: $brand-color;
  color: #fff;
  border-radius: 0.28rem;
}

.post-button-wrapper {
  //position: fixed;
  //bottom: 0;
  //left: 0;
  flex-basis: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
  background-color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  @include safe-padding-bottom(15px);
}

.post-wrapper {
  flex-basis: 0;
  flex-grow: 1;
  //height: 100%;
  box-sizing: border-box;
  //padding-top: 46px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100vw;
}

.post-title {
  flex-shrink: 0;
  background-color: #fff;
  height: 44px;
  line-height: 44px;
  font-size: 12px;
  font-weight: bold;
  padding-left: 0.7rem;
  border-bottom: 1px solid $border-color;
  position: relative;
  z-index: 1;
}

.post-card {
  display: flex;
  justify-content: space-between;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  padding-bottom: 0.7rem;
  font-size: 12px;
  border-bottom: 1px solid $border-color;

  .left {
    flex-grow: 1;

    .post-card-title {
      color: $brand-color;
      height: 38px;
      line-height: 38px;
    }

    .post-card-desc {
      //@include text-ellipsis-2(3);
    }

    .post-card-footer {
      display: flex;
      justify-content: flex-end;

      .post-card-status {
        color: #7d7d7d;
        margin-top: 1rem;

        * {
          margin-left: 1rem;
        }
      }
    }
  }

  .right-button {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-button {
      width: 60px;
      height: 26px !important;
      border-radius: 1rem;
    }
  }
}

.pulldown-bswrapper {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: url("~@/assets/images/tree.png") no-repeat 50% 50%;
  background-size: contain;
  box-sizing: border-box;

  .pulldown-wrapper {
    position: absolute;
    width: 100%;
    padding: 1.42rem;
    box-sizing: border-box;
    transform: translateY(-100%) translateZ(0);
    text-align: center;
    color: #999;
  }

  .pullup-tips {
    color: #999;
    text-align: center;
    padding: 20px;
  }
}

.post-page-content {
  box-sizing: border-box;
  //padding: 0.4rem 0.3rem;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex-basis: 0;
  flex-grow: 1;
  position: relative;
}
</style>
